import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="inbox"
export default class extends Controller {
  static targets = ['preview', 'item']

  connect () {
    this.previewTarget.addEventListener('turbo:frame-render', this.handlePreviewFrameRender)
    document.addEventListener('turbo:before-cache', this.clearPreview)
  }

  disconnect () {
    this.previewTarget.removeEventListener('turbo:frame-render', this.handlePreviewFrameRender)
    document.removeEventListener('turbo:before-cache', this.clearPreview)
  }

  itemTargetConnected () {
    this.deselectItems()
    if (this.previewTarget.src) {
      this.selectItem(this.previewTarget.src)
    }
  }

  getItemId (src) {
    const url = new URL(src)
    // Remove all query parameters
    url.search = ''
    return `test_script_step_result_${url.toString().split('/').pop()}`
  }

  // Bound once, as a field: connect and disconnect have to hand
  // removeEventListener the same function they added.
  handlePreviewFrameRender = (event) => {
    if (event.target === this.previewTarget) {
      this.deselectItems()
      this.selectItem(event.target.src)
    }
  }

  // Turbo Drive previews the cached snapshot of a page it has visited before, so
  // filtering and then following a link back to a URL already visited would flash
  // the result that happened to be open when that snapshot was taken. The frame
  // arrives empty from the server, so it goes into the cache empty too.
  clearPreview = () => {
    this.previewTarget.removeAttribute('src')
    this.previewTarget.innerHTML = ''
    this.deselectItems()
  }

  deselectItems () {
    this.itemTargets.forEach((item) => {
      item.classList.remove('is-selected')
    })
  }

  selectItem (src) {
    const itemId = this.getItemId(src)
    const itemElement = document.getElementById(itemId)
    if (itemElement) {
      itemElement.firstElementChild.classList.add('is-selected')
    }
  }
}
